import { render, staticRenderFns } from "./SectionAdministration.vue?vue&type=template&id=d14cab44&"
import script from "./SectionAdministration.vue?vue&type=script&lang=js&"
export * from "./SectionAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports